import { forwardRef } from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import type {
  TPopoverTriggerElement,
  TPopoverTriggerProps,
} from "@/ui/components/overlay/Popover/Popover.config";

export const PopoverTrigger = forwardRef<TPopoverTriggerElement, TPopoverTriggerProps>(
  (props, ref) => (
    <PopoverPrimitive.Trigger
      ref={ref}
      data-component="PopoverTrigger"
      {...props}
    />
  ),
);

PopoverTrigger.displayName = PopoverPrimitive.Trigger.displayName;
